import { useEffect, useState } from 'react'
import './DomainSelector.scss'
import { DropdownButton, Dropdown } from 'react-bootstrap'
import ICustomer from '../../../common/interfaces/customer/ICustomer'
import ICustomerDomain from '../../../common/interfaces/customer/ICustomerDomain'



type ComponentProps = {
  customer:ICustomer
  handleDomainChangeRequest: (domain:string) => void
}

const DomainSelector = (props:ComponentProps) => {

  const [domainList, setDomainList] = useState<string[]>([])
  const [domainSelected, setDomainSelected] = useState<string>('')
  const [domainListInitialized, setDomainListInitialized] = useState<boolean>(false)
  
  useEffect(() => {

      const domainNames:string[]|null = []
      if (props.customer.sense.domains)
      {
        props.customer.sense.domains.map((domain:ICustomerDomain) => {
          return domainNames.push(domain.name)
        })
        setDomainList(domainNames)
        setDomainSelected(domainNames[0])
      }
      setDomainListInitialized(true)
  }, [])

  const handleSelect = (selectedItem:any) => {
    if (!selectedItem || !domainListInitialized) return
    const selectedDomainTyped:string = selectedItem
    setDomainSelected(selectedItem)
    props.handleDomainChangeRequest(selectedDomainTyped)
  }  
  

  return (
    <div id='domain-selector'>
      {
        domainList && domainList.length > 0 && domainSelected &&
        <DropdownButton id='domain-selection-drop-down-button' variant='secondary' onSelect={(selectedItem) => handleSelect(selectedItem)} title={domainSelected}>
        {
          domainList.map((item:any, domainIndex:any) => (
            (
              <Dropdown.Item key={domainIndex} eventKey={item}>
                {item}
              </Dropdown.Item>
            )
          ))
        }
        </DropdownButton>
      }
    </div>
  )
}



export default DomainSelector
